<a
  class="pro-tag"
  [class.center]="center"
  [class.small]="small"
  [class.no-top]="noTop"
  [routerLink]="'/a/checkout/' + productName"
  [appTooltip]="text"
  [skipDelay]="true"
  appClickTrack
  name="pro-tag"
  [location]="location"
  (click)="closeDialogs()"
  *ngIf="allowPricingLink && !state.plan?.trialEnd"
>
  <div class="pro-tag-inner">
    <app-svg src="/assets/icons/sparks.svg" size="-1"></app-svg>
    <span *ngIf="!small">{{ productName | capitalize }}</span>
  </div>
</a>

<a
  class="pro-tag"
  [class.center]="center"
  [class.small]="small"
  [routerLink]="'/a/pricing'"
  [queryParams]="productName ? { product: productName } : undefined"
  [appTooltip]="text"
  [skipDelay]="true"
  (click)="closeDialogs()"
  *ngIf="allowPricingLink && state.plan?.trialEnd"
>
  <div class="pro-tag-inner">
    <app-svg src="/assets/icons/sparks.svg" size="-1"></app-svg>
    <span *ngIf="!small">{{ productName | uppercase }}</span>
  </div>
</a>

<div
  class="pro-tag"
  [class.small]="small"
  [appTooltip]="'Ask an admin to upgrade to use this feature'"
  [skipDelay]="true"
  *ngIf="!allowPricingLink"
>
  <div class="pro-tag-inner">
    <app-svg src="/assets/icons/sparks.svg" size="-1"></app-svg>
    <span *ngIf="!small">{{ productName | uppercase }}</span>
  </div>
</div>
